<ng-template let-item="item">
    <div class="d-flex align-items-center">
        <div>{{item.name}}</div>
        <div *ngIf="item.emailSend" class="d-flex align-items-center ml-5px">
            <mat-icon class="email">email</mat-icon>
        </div>
    </div>
</ng-template>
